import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FloorplanFilters, FloorplansList, LoadingScreen } from '../../shared';
import { useFloorplanFilters } from './hooks/useFloorplanFilters';
import { resetVisualizer, setActiveFloorplanId } from '../../../store/visualizerSlice';
import styles from './FloorPlansPage.module.css';

export default function FloorPlansPage() {
    const { floorplans, loading, dataLoaded } = useSelector(state => state.floorplan);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [filters, setFilters] = useState({
        homeType: '',
        beds: ''
    });

    // Use custom hooks for complex logic
    const { availableHomeTypes, availableBeds, filteredFloorplans } =
        useFloorplanFilters(floorplans, filters);

    // Event handlers
    const handleSelectPlan = (plan) => {
        console.log('Selected plan:', plan);

        // Reset visualizer state to clear any previous selections
        dispatch(resetVisualizer());
        console.log('Visualizer state reset - starting fresh');

        const floorplanId = plan?.id;
        if (floorplanId == null) {
            console.warn('Selected plan has no id, cannot navigate');
            return;
        }

        dispatch(setActiveFloorplanId(floorplanId));
        navigate(`/visualizer/${floorplanId}`, {
            state: {
                floorplan: plan
            }
        });
    };

    const handleFilterChange = (filterName, value) => {
        setFilters(prev => ({ ...prev, [filterName]: value }));
    };

    const handleClearFilters = () => {
        setFilters({ homeType: '', beds: '' });
    };

    // Loading state
    if (loading || !dataLoaded) {
        return <LoadingScreen isOpen={true} />;
    }

    // No data state
    if (floorplans.length === 0) {
        return (
            <section className={styles.container}>
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <h2>No floorplan data available</h2>
                    <p>Please check the browser console for error messages.</p>
                </div>
            </section>
        );
    }

    return (
        <section className={styles.container}>
            <FloorplanFilters
                filters={filters}
                onFilterChange={handleFilterChange}
                onClearFilters={handleClearFilters}
                availableHomeTypes={availableHomeTypes}
                availableBeds={availableBeds}
            />

            <div className={styles.scrollableContent}>
                <FloorplansList
                    floorplans={filteredFloorplans}
                    onSelectPlan={handleSelectPlan}
                />
            </div>
        </section>
    );
}
